import { UserCircleDashed } from "@phosphor-icons/react";
import { useState } from "react";

import { useUser } from "../services/user";

type Props = {
  size?: number;
  className?: string;
};

// Rewrite legacy HTTP MinIO URLs to the HTTPS API proxy (mixed-content fix)
const normalizePictureUrl = (url: string): string => {
  const MINIO_PREFIX = "http://72.62.150.192:9000/stylingcv-storage/";
  const API_PREFIX = "/api/storage/";
  if (url.startsWith(MINIO_PREFIX)) return API_PREFIX + url.slice(MINIO_PREFIX.length);
  return url;
};

export const UserAvatar = ({ size = 36, className }: Props) => {
  const { user } = useUser();
  const [imgError, setImgError] = useState(false);

  if (!user) return null;

  const placeholder = (
    <div
      style={{ width: size, height: size }}
      className="flex items-center justify-center rounded-full bg-secondary text-center text-secondary-foreground"
    >
      <UserCircleDashed size={size * 0.75} weight="regular" className="text-secondary-foreground" />
    </div>
  );

  const pictureSrc = user.picture ? normalizePictureUrl(user.picture) : null;

  const picture =
    pictureSrc && !imgError ? (
      <img
        alt={user.name}
        src={pictureSrc}
        className="block rounded-full"
        style={{ width: size, height: size, objectFit: "cover" }}
        onError={() => setImgError(true)}
      />
    ) : (
      placeholder
    );

  return <div className={className}>{picture}</div>;
};
